import pkg from "../package.json";

export const APP_VERSION: string = pkg.version;
